"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("./styles.scss");
//# sourceMappingURL=index.js.map